import { useContext, type ReactNode } from 'react';
import { Navigate } from '@tanstack/react-router';
import { FeatureFlagContext } from './FeatureFlagProvider';

interface FeatureFlagRouteProps {
  flag: string;
  children: ReactNode;
  /** Where to redirect if the flag is disabled. Defaults to '/dashboard'. */
  redirectTo?: string;
}

/**
 * Route guard that only renders children if the given feature flag is enabled.
 *
 * Unlike FeatureFlagGuard (which hides the content in-place), this component
 * redirects to a fallback route — use it for entire route segments where the
 * page should not be accessible at all when the feature is off.
 */
export function FeatureFlagRoute({
  flag,
  children,
  redirectTo = '/dashboard',
}: FeatureFlagRouteProps): JSX.Element {
  const context = useContext(FeatureFlagContext);

  /*
    Enquanto as flags nao chegaram, `flags` esta vazio e toda flag responde
    `false`. Redirecionar nesse instante expulsa o usuario de uma rota que ele
    tem: abrir /manufacturing/boms direto na barra de endereco (ou dar F5 nela)
    caia no /dashboard antes da primeira resposta do servidor. Descoberto ao
    capturar a tela de BOM — a captura saiu com o Painel Executivo.

    Durante o carregamento nao se decide nada: nao renderiza e nao redireciona.
  */
  if (!context || context.isLoading) {
    return <></>;
  }

  if (!(context.flags[flag] ?? false)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
